import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IStore } from '../../reducers';
import useTicker from '../../hooks/useTicker';
import useTickerPool from './useTickerPool';
import PoolInfo from './PoolInfo';
import PoolTabs from './PoolTabs';
import CoinNews from '../Info/CoinNews';
import DexCoinLiquidity from '../Info/DexCoin/DexCoinLiquidity';
import PoolScore from './PoolScore';

import './styles.scss';

export enum PoolWidgetTab {
  info = 'About',
  liquidity = 'Liquidity',
  news = 'News',
  score = 'Score',
}

const PoolWidget = () => {
  const [tab, setTab] = useState(PoolWidgetTab.info);

  const current = useSelector((state: IStore) => state.current);

  const ticker = useTicker(current);
  const { loading, rows, extraRows, poolInfo, scoreInfo, sameBaseTickers } =
    useTickerPool(current, ticker);

  useEffect(() => {
    setTab(PoolWidgetTab.info);
  }, [current.id]);

  return (
    <div className='pool_widget'>
      <PoolTabs
        activeTab={tab}
        setTab={setTab}
        current={current}
        news={poolInfo.news}
        score={scoreInfo}
      />
      {tab === PoolWidgetTab.info && (
        <PoolInfo
          current={current}
          loading={loading}
          rows={rows}
          securityRows={extraRows}
          links={poolInfo.links}
          sameBaseTickers={sameBaseTickers}
        />
      )}
      {tab === PoolWidgetTab.liquidity && (
        <DexCoinLiquidity
          chain={ticker.chain}
          address={current.address}
          baseDecimals={ticker.base_decimals}
          quoteDecimals={ticker.quote_decimals}
          base={ticker.base}
          quote={ticker.quote}
          flipped={current.flipped}
        />
      )}
      {tab === PoolWidgetTab.news && (
        <CoinNews
          slug={ticker.base}
          data={poolInfo.news?.items}
          AI={poolInfo.news?.ai}
        />
      )}
      {tab === PoolWidgetTab.score && scoreInfo && (
        <PoolScore rows={scoreInfo.rows} current={current} />
      )}
    </div>
  );
};

export default PoolWidget;
